import { getLoginUrl } from '../utils'

export const errorHandler = (error) => {
  console.log('errorHandler => error:', error)
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.clear()
      // *Session expire hone par login page par bhejo, login ke baad
      // wapas usi page par aana chahiye jahan user tha.
      window.location.replace(getLoginUrl())
    }
    return error.response.data.error ? error.response.data.error : error.response.data.message;
  } else if (error.request) {
    return error.message;
  } else {
    return 'Something went wrong';
  }
};
